import Home from "@/components/Pages/Home";
import Home2 from "@/components/Pages/Home2";
import Signature from "@/components/Pages/Signature";
import Guarantee from "@/components/Pages/Guarantee";
import CompareEstimate from "@/components/Pages/CompareEstimate";
import NewCompareEstimate from "@/components/Pages/NewCompareEstimate";
import Gift from "@/components/Pages/Gift";
import MyInsurance from "@/components/Pages/MyInsurance";
import MyPage from "@/components/Pages/MyPage";

import InsuranceDetail from "@/components/Pages/InsuranceDetail";
import InsuranceDetailPrice from "@/components/Pages/InsuranceDetailPrice";

import Alliance from "@/components/Pages/AboutUs/Alliance";
import History from "@/components/Pages/AboutUs/History";
import Location from "@/components/Pages/AboutUs/Location";
import Overview from "@/components/Pages/AboutUs/Overview";
import Certificate from "@/components/Pages/AboutUs/Certificate";

import Notice from "@/components/Pages/CS/Notice";
import BulletinBoard from "@/components/Pages/CS/BulletinBoard";
import InsuranceResources from "@/components/Pages/CS/InsuranceResources";
import FAQ from "@/components/Pages/CS/FAQ";
import Auth from "@/components/Pages/Auth";

import SendMail from "@/components/Pages/SendMail";

import EstimateLosslessMedicalInsurance from "@/components/Pages/Estimate/LosslessMedicalInsurance";
import CancerInsurance from "@/components/Pages/Estimate/CancerInsurance";
import CarInsurance from "@/components/Pages/Estimate/CarInsurance";
import ChildInsurance from "@/components/Pages/Estimate/ChildInsurance";
import DementiaInsurance from "@/components/Pages/Estimate/DementiaInsurance";
import DriverInsurance from "@/components/Pages/Estimate/DriverInsurance";
import FetalInsurance from "@/components/Pages/Estimate/FetalInsurance";
import FireInsurance from "@/components/Pages/Estimate/FireInsurance";
import PensionInsurance from "@/components/Pages/Estimate/PensionInsurance";
import PetInsurance from "@/components/Pages/Estimate/PetInsurance";
import TermInsurance from "@/components/Pages/Estimate/TermInsurance";
import WholeLifeInsurance from "@/components/Pages/Estimate/WholeLifeInsurance";
import DentalInsurance from "@/components/Pages/Estimate/DentalInsurance";
import Consultation from "@/components/Pages/Estimate/Consultation";
import LifeEstimateConsultation from "@/components/Pages/Estimate/LifeEstimateConsultation";
import EstimateConsultation from "@/components/Pages/Estimate/EstimateConsultation";
import Service from "@/components/Pages/Estimate/Service";

import DenyEmail from "@/components/Pages/DenyEmail";

import RepairEstimate from "@/components/Pages/RepairEstimate"
import RepairRequest from "@/components/Pages/RepairRequest"
import RepairRequest2 from "@/components/Pages/RepairRequest2"
import RepairDetail from "@/components/Pages/RepairDetail"
import RepairDetail2 from "@/components/Pages/RepairDetail2"
import ReservationRepair from "@/components/Pages/ReservationRepair"
import RequestRepairEstimate from "@/components/Pages/RequestRepairEstimate"
// import SignatureOld from "@/components/Pages/SignatureOld";

import lifeEstimate from "@/view/page/lifeEstimate"
import LifeEstimateResult from '@/components/Pages/Estimate/LifeEstimateResult';

import Contents from '@/components/Pages/Contents';
import ContentDetail from '@/components/Pages/ContentDetail';

import DutyNotice from '@/components/Pages/DutyNotice';

import Introduction from '@/components/Includes/IntroductionForm';

var modalItems = {
  EstimateLosslessMedicalInsurance,
  CarInsurance,
  CancerInsurance,
  ChildInsurance,
  DementiaInsurance,
  DriverInsurance,
  DentalInsurance,
  FetalInsurance,
  FireInsurance,
  PensionInsurance,
  PetInsurance,
  TermInsurance,
  WholeLifeInsurance,
  Consultation,
  EstimateConsultation,
  Service,
  lifeEstimate,
  LifeEstimateConsultation,
  LifeEstimateResult,
  DutyNotice
};


const routes = [
  { name: "Home", path: "/", alias: "/reservation", component: Home2, meta: { name: "홈" } },
  { name: "Home2", path: "/mainb", component: Home, meta: { name: "홈" } },
  { name: "NewCompareEstimate", path: "/new-compare", component: NewCompareEstimate, meta: { name: "비교견적" } },
  { name: "CompareEstimate", path: "/compare", component: CompareEstimate, meta: { name: "비교견적" } },
  { name: "Guarantee", path: "/guarantee", component: Guarantee, meta: { name: "5대보증" } },
  { name: "Gift", path: "/gift", component: Gift, meta: { name: "6대사은" } },
  { name: "Signature", path: "/signature/:id", component: Signature, meta: { name: "자필서명" }, props: true },
  // { name: "SignatureOld", path: "/signatureold/:id", component: SignatureOld, meta: { name: "자필서명" }, props: true },
  { name: "MyInsurance", path: "/mypage/insurance", component: MyInsurance, meta: { name: "MY보험"} },
  { name: "MyPage", path: "/mypage/setting", component: MyPage, meta: { name: "고객정보관리"} },

  { name: "InsuranceDetail", path: "/mypage/insurance/detail", component: InsuranceDetail, meta: { name: "보험상세" }},
  { name: "InsuranceDetailPrice", path: "/mypage/insurance/detail/price", component: InsuranceDetailPrice, meta: { name: "보험상세가격" }},

  { name: "SendMail", path: "email/estimate.compare", component: SendMail, meta: { name: "이메일전송" } },

  { name: "Alliance", path: "/aboutus/alliance", component: Alliance, meta: { name: "제휴보험사" } },
  { name: "History", path: "/aboutus/history", component: History, meta: { name: "주요연혁" } },
  { name: "Location", path: "/aboutus/location", component: Location, meta: { name: "위치안내" } },
  { name: "Overview", path: "/aboutus/overview", component: Overview, meta: { name: "회사개요" } },
  { name: "Certificate", path: "/aboutus/certificate", component: Certificate, meta: { name: "대리점등록증" } },

  { name: "Notice", path: "/cs/notice", component: Notice, meta: { name: "공지사항" } },
  { name: "BulletinBoard", path: "/cs/board", component: BulletinBoard, meta: { name: "4대 공개 게시판" } },
  { name: "InsuranceResources", path: "/cs/insurance-resources", component: InsuranceResources, meta: { name: "자주하는 질문" } },
  { name: "FAQ", path: "/cs/faq", component: FAQ, meta: { name: "보험 자료실" } },

  { name: "Auth", path: "/auth", component: Auth, meta: { name: "인증", onlyGuest: true } },

  { name: "EstimateLosslessMedicalInsurance", path: "/estimate/lossless-medical-insurance", component: EstimateLosslessMedicalInsurance, meta: { name: "실손의료보험 견적서" } },
  { name: "CarInsurance", path: "/estimate/car-insurance", component: CarInsurance, meta: { name: "자동차보험 견적서" } },
  { name: "CancerInsurance", path: "/estimate/cancer-insurance", component: CancerInsurance, meta: { name: "암보험 견적서" } },
  { name: "ChildInsurance", path: "/estimate/child-insurance", component: ChildInsurance, meta: { name: "어린이보험 견적서" } },
  { name: "DementiaInsurance", path: "/estimate/dementia-insurance", component: DementiaInsurance, meta: { name: "치매보험 견적서" } },
  { name: "DentalInsurance", path: "/estimate/dental-insurance", component: DentalInsurance, meta: { name: "치아보험 견적서" } },
  { name: "DriverInsurance", path: "/estimate/driver-insurance", component: DriverInsurance, meta: { name: "운전자보험 견적서" } },
  { name: "FetalInsurance", path: "/estimate/fetal-insurance", component: FetalInsurance, meta: { name: "태아보험 견적서" } },
  { name: "FireInsurance", path: "/estimate/fire-insurance", component: FireInsurance, meta: { name: "화재보험 견적서" } },
  { name: "PensionInsurance", path: "/estimate/pension-insurance", component: PensionInsurance, meta: { name: "연금보험 견적서" } },
  { name: "PetInsurance", path: "/estimate/pet-insurance", component: PetInsurance, meta: { name: "펫보험 견적서" } },
  { name: "TermInsurance", path: "/estimate/term-insurance", component: TermInsurance, meta: { name: "정기보험 견적서" } },
  { name: "WholeLifeInsurance", path: "/estimate/whole-life-insurance", component: WholeLifeInsurance, meta: { name: "종신보험 견적서" } },
  { name: "Consultation", path: "/estimate/consultation", component: Consultation, meta: { name: "전화상담" } },
  { name: "EstimateConsultation", path: "/estimate/estimateconsultation", component: EstimateConsultation, meta: { name: "상담예약" }},
  // { name: "EstimateConsultationURL", path: "/reservation", redirect: { name: 'EstimateConsultation' }, meta: { name: "상담예약2" }},
  { name: "Service", path: "/estimate/service", component: Service, meta: { name: "서비스" } },
  { name: "DenyEmail", path: "/deny_email", component: DenyEmail, meta: { name: "이메일 수신 거부" } },

  // 정비.수리 견적 요청 페이지 추가
  { name: "RepairEstimate", path: "/mypage/insurance/repair", component: RepairEstimate, meta: { name: "정비·수리 견적요청" } },  
  { name: "RepairRequest", path: "/mypage/insurance/repair2", component: RepairRequest, meta: { name: "정비·수리 견적요청" } },
  { name: "RepairRequest2", path: "/mypage/insurance/repair3", component: RepairRequest2, meta: { name: "정비·수리 견적요청" } },
  { name: "RepairDetail", path: "/mypage/insurance/repairdetail", component: RepairDetail, meta: { name: "정비·수리 상세조회" } },
  { name: "RepairDetail2", path: "/mypage/insurance/repairdetail2", component: RepairDetail2, meta: { name: "정비·수리 상세조회" } },
  { name: "ReservationRepair", path: "/mypage/insurance/reservationrepair", component: ReservationRepair, meta: { name: "정비·수리 예약" } },
  { name: "RequestRepairEstimate", path: "/request/repair/estimate", component: RequestRepairEstimate, meta: { name: "정비·수리 견적요청서" } },

  { name: "lifeEstimate", path: "/life-estimate", component: lifeEstimate, meta: { name: "생명보험 견적서" } },
  { name: "LifeEstimateConsultation", path: "/life-estimate-consultation", component: LifeEstimateConsultation, meta: { name: "상담예약" } },
  { name: "LifeEstimateResult", path: "/life-estimate-result", component: LifeEstimateResult, meta: { name: "보험료 비교표 결과" }, props: true },
  
  { name: "Contents", path: "/contents", component: Contents, meta: { name: "카드뉴스" }, props: true },
  { name: "ContentDetail", path: "/content", component: ContentDetail, meta: { name: "콘텐츠 상세" }, props: true },

  { name: "DutyNotice", path: "/duty-of-notice", component: DutyNotice, meta: { name: "알릴 의무" } },

  { name: "Introduction", path: "/intro", component: Introduction, meta: { name: "회사소개" } }
];

export { routes, modalItems };
